import { useMutation } from '@tanstack/react-query';

import { updateCompanySettings, CompanySettingsUpdateParams, CompanySetting } from './api';
import { successHandler } from '@/utils/notifications';
import { useAppDispatch } from '@/store/hooks';
import { COMPANY_SETTINGS } from './query-keys';
import queryClient from '@/utils/query';

const mergeCompanySettings = (
  previous: CompanySetting[] | undefined,
  updates: CompanySetting[]
): CompanySetting[] => {
  if (!previous?.length) return updates;

  const byKey = new Map(previous.map(item => [item.key, item]));
  for (const item of updates) {
    byKey.set(item.key, item);
  }

  return [...byKey.values()];
};

export const useUpdateCompanySettings = (id: string) => {
  const dispatch = useAppDispatch();

  return useMutation({
    mutationFn: (params: CompanySettingsUpdateParams) => updateCompanySettings(id, params),
    onSuccess: (_response, params) => {
      queryClient.setQueryData<CompanySetting[]>([COMPANY_SETTINGS, id], previous =>
        mergeCompanySettings(previous, params)
      );
      dispatch(successHandler({ title: 'Success!', message: 'Settings saved successfully' }));
    },
    retry: false
  });
};
